'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dGroup$002dSite$002dPage$0024 from "./presto.-Edit-Group-Site-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002457 from "./presto.-Presto-Router$$anon$57.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$56() {
  this.ble = null;
  this.bl6 = null;
  this.bl7 = false;
  this.blf = null;
  this.blg = false;
  this.blj = null;
  this.blc = null;
  this.bld = false;
  this.bl8 = null;
  this.bl9 = false;
  this.bla = null;
  this.blb = false;
  this.blh = false;
  this.bli = false;
  this.ble = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.blj = "EditGroupSitePage";
}
export { $c_Lpresto_PrestoRouter$$anon$56 as $c_Lpresto_PrestoRouter$$anon$56 };
$p = $c_Lpresto_PrestoRouter$$anon$56.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$56;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$56() {
}
export { $h_Lpresto_PrestoRouter$$anon$56 as $h_Lpresto_PrestoRouter$$anon$56 };
$h_Lpresto_PrestoRouter$$anon$56.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.ble;
});
$p.M = (function() {
  if ((!this.bl7)) {
    this.bl6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bl7 = true;
  }
  return this.bl6;
});
$p.O = (function() {
  if ((!this.blg)) {
    this.blf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.blg = true;
  }
  return this.blf;
});
$p.D = (function() {
  return this.blj;
});
$p.t = (function() {
  if ((!this.bld)) {
    this.blc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bld = true;
  }
  return this.blc;
});
$p.N = (function() {
  if ((!this.bl9)) {
    this.bl8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iQ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().mm(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bl9 = true;
  }
  return this.bl8;
});
$p.Q = (function() {
  if ((!this.blb)) {
    this.bla = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002457.$c_Lpresto_PrestoRouter$$anon$57();
    this.blb = true;
  }
  return this.bla;
});
$p.v = (function() {
  if ((!this.bli)) {
    this.blh = false;
    this.bli = true;
  }
  return this.blh;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee427) => ((p) => \u03b4scrutinee427.cGY(p)))($j_presto$002e$002dEdit$002dGroup$002dSite$002dPage$0024.$m_Lpresto_EditGroupSitePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$56 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$56, "presto.PrestoRouter$$anon$56", ({
  Ow: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$56 as $d_Lpresto_PrestoRouter$$anon$56 };
//# sourceMappingURL=presto.-Presto-Router$$anon$56.js.map
